import { createContext } from 'react';
export var AddUndoableMutationContext = createContext(function () { });
//# sourceMappingURL=AddUndoableMutationContext.js.map